<template lang="pug">
v-container(grid-list-xl, fluid)
  WarningSelect(v-show="!estabelecimentoSelecionado")
  v-container(grid-list-xl, fluid, v-show="estabelecimentoSelecionado")
    v-layout(row, wrap)
      v-flex(lg12)
        v-card.pa-3.br-10.cardPadrao
          v-layout(row, wrap)
            v-flex(lg12)
              v-btn(large, outline, round, color="grey", @click="openDialogBoletos()")
                v-icon(left, color="verdeFinanceiro") receipt
                span(v-if="!$root.boletosDisponiveis").text-capitalize.title.black--text.Poppins Boletos
                span(v-if="$root.boletosDisponiveis").text-capitalize.title.black--text.Poppins Boletos ({{$root.boletosDisponiveis}})

              v-btn(large, outline, round, color="grey", @click="openDialogRepasse()", v-if="!$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO")
                v-icon(left, color="verdeFinanceiro") swap_horiz
                span.text-capitalize.title.black--text.Poppins Repasses
          v-layout(row, wrap)
            v-flex.md4.xs12
          v-layout(row, wrap)
            v-flex.md12.xs12.br-5.caixaDoItem
              v-card.card--flex-toolbar.mt-0.br-5.cardDoItem
                faturas(ref="cardFaturas")

  DialogRepasses(ref="dialogRepasses")
  DialogBoletos(ref="dialogBoletos")

</template>

<script>
import _ from "lodash";

import DialogRepasses from '@/pages/financeiro/repasse/Dialog';
import DialogBoletos from '@/pages/financeiro/boleto/Dialog';
import faturas from '@/pages/financeiro/fatura/Lista';
import WarningSelect from '@/components/WarningSelect';

export default {
  components: {
    faturas,
    DialogBoletos,
    DialogRepasses,
    WarningSelect,
  },
  data () {
    return {
      venda: null,
      mesSelecionado: null,
    }
  },
  created () {
    const vm = this
    window.getApp.$on("CHANGE_ESTABELECIMENTO", vm.onChangeEstabelecimento);
  },
  beforeDestroy () {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted () {
    const vm = this
    vm.onChangeEstabelecimento()
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    estabelecimentos(){
      return this.$root.estabelecimentos;
    },
  },
  methods: {
    openDialogRepasse(){
      this.$refs.dialogRepasses.open(this.estabelecimentoSelecionado.id);
    },
    openDialogBoletos(){
      this.$refs.dialogBoletos.open(this.estabelecimentoSelecionado.id);
    },
    onChangeEstabelecimento () {
      console.log('CHANGE_ESTABELECIMENTO FINANCEIRO', this.estabelecimentoSelecionado)
      if (this.estabelecimentoSelecionado) {
        this.setEstabelecimento()
      }
      this.$forceUpdate();
    },
    setEstabelecimento () {
      const enums = this.$root.enums;
      const venda = this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.vendas ? _.find(this.estabelecimentoSelecionado.vendas, o => {
        return o.status == enums.STATUS.VENDA_ATIVA || o.status == enums.STATUS.VENDA_SUSPENSA || o.status == enums.STATUS.VENDA_PENDENTE;
      }) : null;

      this.$refs.cardFaturas.update(venda);
    },
  },
}
</script>

<style scoped>
.Poppins {
  font-family: "Poppins" !important;
}
.Capitalize{
  text-transform: capitalize;
}
.br-5 {
  border-radius: 5px !important;
}
.br-10 {
  border-radius: 10px !important;
}
.cardPadrao {
    box-shadow:none !important;
    background-color: transparent;
    margin-bottom: 25px;
  }
.caixaDoItem {
  padding: 12px !important;
  /*max-height: 75vh;*/
  box-shadow:none !important;
}
.cardDoItem {
  overflow: hidden;
  /* border: 1px solid rgba(17, 19, 18, 0.2); */
  /*height: 72vh;*/
  box-shadow:none !important;
  background-color: transparent;
}
</style>
